// User & Auth
export const USER_QUERY_KEY = 'user';
export const LOGIN_QUERY = 'login';
export const REGISTER_QUERY = 'register';
export const RESEND_VERIFICATION_QUERY = 'resendVerification';
export const SEND_PASSWORD_RESET_QUERY = 'sendPasswordReset';
export const REFRESH_QUERY = 'refresh';
export const PASSWORD_RESET_WITH_TOKEN_QUERY = 'passwordResetWithToken';
export const CUSTOMER_SETUP_ACCOUNT_QUERY = 'customerSetupAccount';

// Customer & Company
export const CUSTOMER_QUERY_KEY = 'customer';
export const CUSTOMERS_QUERY_KEY = 'customers';
export const COMPANY_USERS_QUERY_KEY = 'companyUsers';
export const COMPANY_MEMBERS_QUERY_KEY = 'companyMembers';
export const INVITE_CUSTOMER_QUERY_KEY = 'invite';
export const VALIDATE_CUSTOMER_INVITE_QUERY = 'validateCustomerInvite';

// Environment & Applications
export const ENVIRONMENTS_QUERY_KEY = 'environments';
export const APPLICATIONS_QUERY_KEY = 'applications';
export const APPLICATION_VERSIONS_QUERY_KEY = 'applicationVersions';
export const APPLICATION_QUERY_KEY = 'application';

// Devices & WDAC
export const DEVICES_QUERY_KEY = 'devices';
export const WDAC_READINESS_DEVICES_QUERY_KEY = 'wdacReadinessDevices';
export const DEVICE_QUERY_KEY = 'device';
export const DEVICE_LOGS_QUERY_KEY = 'logFiles';
export const DEVICE_UNMATCHED_FILES_QUERY_KEY = 'deviceUnmatchedFiles';
export const DEVICE_POLICY_QUERY_KEY = 'devicePolicy';
export const DEVICE_BASE_POLICY_QUERY_KEY = 'wdacBasePolicy';
export const DEVICES_EXPORT_KEY = 'devicesExport';
export const UNMATCHED_DEVICE_ITEMS = 'unmatchedDeviceItems';
export const DEVICE_TAGS_QUERY_KEY = 'deviceTags';
export const DOWNLOADS_QUERY_KEY = 'downloads';

// WDAC Specific
export const WDAC_TABS_DATA_COUNTS_KEY = 'wdacTabsDataCounts';
export const WDAC_APP_QUERY_KEY = 'wdacApp';
export const WDAC_SCRIPT_EXECUTION_DEVICES_KEY = 'wdacScriptExecutionDevices';
export const WDAC_DEVICE_IMPACTED_DEVICES_KEY = 'wdacAppImpactedDevices';
export const WDAC_APP_FILE_SET_FILES_KEY = 'wdacAppFileSetFiles';
export const WDAC_PACKAGED_APP_DEVICE_IMPACTED_DEVICES_KEY = 'wdacPackagedAppImpactedDevices';
export const WDAC_MANAGED_INSTALLER_DEVICES_KEY = 'wdacManagedInstallerDevices';
export const WDAC_CATALOG_INVENTORY_DEVICES_KEY = 'wdacCatalogInventoryDevices';
export const WDAC_PACKAGED_APP_GENERAL_QUERY_KEY = 'wdacPackagedAppGeneral';
export const WDAC_MANAGED_INSTALLER_GENERAL_QUERY_KEY = 'wdacManagedInstallerGeneral';
export const WDAC_CATALOG_INVENTORY_DETAILS_QUERY_KEY = 'wdacManagedInstallerGeneral';
export const WDAC_SCRIPT_EXECUTION_DETAILS_QUERY_KEY = 'wdacScriptExecutionDetails';
export const WDAC_APP_MATCHED_APPLICATIONS_KEY = 'wdacAppMatchedApplications';
export const WDAC_MANAGED_INSTALLER_AFFECTED_DEVICES_KEY = 'wdacManagedInstallerAffectedDevices';
export const WDAC_MANAGED_INSTALLER_UNAFFECTED_DEVICES_KEY =
  'wdacManagedInstallerUnaffectedDevices';
export const WDAC_MANAGED_INSTALLER_TAB_COUNTS_KEY = 'wdacManagedInstallerTabCounts';
export const WDAC_MANAGED_INSTALLER_EXPORT_DEVICES_KEY = 'wdacManagedInstallerExportDevices';
export const WDAC_SCRIPT_EXECUTION_AFFECTED_DEVICES_KEY = 'wdacScriptExecutionAffectedDevices';
export const WDAC_CATALOG_INVENTORY_AFFECTED_DEVICES_KEY = 'wdacCatalogInventoryAffectedDevices';
export const CATALOG_INVENTORY_TAB_COUNTS_QUERY_KEY = 'catalogInventoryTabCounts';
export const WDAC_PACKAGED_APP_QUERY_KEY = 'wdacPackagedApp';
export const WDAC_PACKAGED_APP_SIGNATURE_KINDS_QUERY_KEY = 'wdacPackagedAppSignatureKinds';
export const WDAC_DEVICE_POLICY_QUERY_KEY = 'wdacDevicePolicy';
export const WDAC_MANAGED_INSTALLER_QUERY_KEY = 'wdacManagedInstaller';
export const WDAC_CATALOG_INVENTORY_QUERY_KEY = 'wdacCatalogInventory';
export const WDAC_SCRIPT_EXECUTION_QUERY_KEY = 'wdacScriptExecution';

// Device Tabs & Counts
export const RESULTS_TAB_DATA_COUNTS_KEY = 'resultsTabsDataCounts';

// Files & Paths
export const LAST_DOWNLOAD_DATES_KEY = 'lastDownloadDates';
export const FILES_COUNT_KEY = 'filesCount';
export const ALL_FILES_COUNT_KEY = 'allFilesCount';

// Tags & OS
export const TAG_DEVICES_COUNT_QUERY_KEY = 'tagDevicesCount';
export const TAG_DEVICES_QUERY_KEY = 'tagDevices';
export const OS_TYPES_QUERY_KEY = 'osTypes';
export const LOG_TYPES_QUERY_KEY = 'logTypes';
export const OS_SKUS_QUERY_KEY = 'osSkus';
export const OS_VERSIONS_QUERY_KEY = 'osVersions';

// Devices Dashboard
export const DEVICES_DASHBOARD_ENFORCEMENT_QUERY_KEY = 'devicesEnforcementDashboard';
export const DEVICES_DASHBOARD_POLICIES_QUERY_KEY = 'devicesPoliciesDashboard';
export const DEVICES_DASHBOARD_MANAGED_INSTALLER_QUERY_KEY = 'devicesManagedInstallerDashboard';
export const DEVICES_DASHBOARD_VERSION_LOG_COLLECTOR_QUERY_KEY =
  'devicesVersionLogCollectorDashboard';
export const DEVICES_DASHBOARD_CLIENT_HEALTH_BAR_QUERY_KEY = 'devicesClientHealthBarDashboard';
export const DEVICES_DASHBOARD_CLIENT_HEALTH_ISSUES_QUERY_KEY =
  'devicesClientHealthIssuesDashboard';
export const DEVICES_DASHBOARD_ENFORCEMENT_COUNT_QUERY_KEY = 'devicesEnforcementCountDashboard';
export const DEVICES_DASHBOARD_WDAC_READINESS_QUERY_KEY = 'devicesWdacReadinessDashboard';

// Publishers & App counts
export const APP_COUNTS_KEY = 'appCounts';
export const ENVIRONMENT_NAME_QUERY_KEY = 'environmentName';
export const ENVIRONMENT_STATUS_SETTINGS_QUERY_KEY = 'environmentStatusSettings';
